export default __webpack_public_path__ + "static/media/image-3.cd240bf9.png";